import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import React from 'react';

import { ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';

interface AbrdnPlaceholdersProps {
  rendering: ComponentRendering;
  className?: string;
  name: string;
  singleTile?: boolean;
  hardcodedBg?: string;
}

const AbrdnPlaceholders = <T extends AbrdnPlaceholdersProps>({
  rendering,
  className,
  name,
  singleTile = true,
  hardcodedBg,
  ...rest
}: T): React.ReactNode => {
  if (!rendering.placeholders?.[name] || !rendering.placeholders?.[name]?.length) {
    return null;
  }

  return (
    <div className={className}>
      <Placeholder
        name={name}
        rendering={rendering}
        singleTile={singleTile}
        hardcodedBg={hardcodedBg}
        {...rest}
      />
    </div>
  );
};

export default AbrdnPlaceholders;
